import React, { useEffect, useState } from "react";
import BackLink from "../../common/components/BackLink/BackLink";
import { ContactSuccess, LogoDark } from "../../assets";
import {
  getRILOrderData,
  updateRILOrderData,
  uploadRILDocument,
} from "../../redux/features/documentService/documentServiceActions";
import { useDispatch } from "react-redux";
import { isValidFile } from "../../common/utils/functions/helperFunctions";
import toast, { Toaster } from "react-hot-toast";

const RIL = () => {
  const dispatch = useDispatch();
  const [requestData, setRequestData] = useState({});
  const [status, setStatus] = useState("");
  const [payment, setPayment] = useState("");
  const [comment, setComment] = useState("");
  const [documentURL, setDocumentURL] = useState("");
  const [loading, setLoading] = useState({});
  const [success, setSuccess] = useState(false);
  const statusList = ["Created", "Approve", "Delivered", "Reject"];

  const getQueryString = (name) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let url = location;
    if (!url) {
      url = window.location.href;
    }
    const regexS = "[\\?&]" + name + "=([^&#]*)";
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    if (results == null) {
      return "";
    } else {
      return decodeURIComponent(results[1].replace(/\+/g, " "));
    }
  };

  useEffect(() => {
    const secret = getQueryString("secret");
    if (secret) {
      dispatch(getRILOrderData({ secret })).then((res) => {
        if (res?.payload?.response?.status === 200) {
          setRequestData(res?.payload?.response?.data?.data?.item);
          setStatus(res?.payload?.response?.data?.data?.item?.status);
          setLoading(false);
        }
      });
    }
  }, []);

  const handleSubmitRequest = (e) => {
    e.preventDefault();
    const secret = getQueryString("secret");
    const body = {
      orderId: requestData?.orderId,
      status: status,
      payment: payment,
      comments: [comment],
      url: documentURL,
    };
    if (secret) {
      dispatch(updateRILOrderData({ secret, body })).then((res) => {
        if (res?.payload?.response?.status === 200) {
          setSuccess(true);
        }
        setSuccess(true);
      });
    }
  };

  const uploadDocument = (e) => {
    const allowedFiles = ["pdf"];
    if (isValidFile(e, allowedFiles)) {
      const docFormData = new FormData();
      docFormData.append("file", e.target.files[0]);
      docFormData.append("form", requestData?.documentType || "ec");
      dispatch(uploadRILDocument({ docFormData })).then((res) => {
        if (res?.payload?.response?.status === 200) {
          setDocumentURL(res?.payload?.response?.data?.data?.item?.url);
        }
      });
    } else {
      e.target.value = null;
      toast.error("Invalid file type.Please try again.");
    }
  };

  return (
    // Phones: the form was 50% wide (195px at 390) — now full width on a 20px
    // gutter with 48px / 16px controls (16px stops iOS zooming on focus).
    <div className="w-full flex flex-col  items-center min-h-screen gap-10 max-md:gap-6 max-md:px-5 max-md:pb-10 max-md:[&_input]:text-base max-md:[&_label]:text-sm max-md:[&_label]:font-medium max-md:[&_label]:text-slate-700 max-md:[&_select]:h-12 max-md:[&_select]:text-base max-md:[&_textarea]:text-base">
      <Toaster />
      {/* Top-left Back (previous page, or Home when opened from a link). */}
      <div className="w-full px-6 pt-4 max-md:px-0">
        <BackLink fallback="/" />
      </div>
      <div className="w-full flex justify-center mt-12 max-md:mt-4">
        <img src={LogoDark} height={120} width={180} />
      </div>
      {!success && (
        <form
          className="flex flex-col w-[50%] gap-2 max-md:w-full max-md:gap-3"
          onSubmit={(e) => handleSubmitRequest(e)}
        >
          <div className="flex flex-col gap-1">
            <label htmlFor="payment"> Order ID</label>
            <div className="p-2 rounded-lg border border-[#d0d5dd] h-[42px] bg-slate-100 max-md:flex max-md:h-12 max-md:items-center max-md:px-3">
              {requestData?.orderId}
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="payment"> Document</label>
            <div className="p-2 rounded-lg border border-[#d0d5dd] h-[42px] bg-slate-100 uppercase max-md:flex max-md:h-12 max-md:items-center max-md:px-3">
              {requestData?.documentType}
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="payment"> Status</label>

            <select
              name="status"
              className="py-2 px-3 rounded-lg border border-[#d0d5dd]"
              onChange={(e) => {
                setStatus(e.target.value);
              }}
            >
              {statusList?.map((item) => {
                return (
                  <option
                    value={item}
                    className="p-2"
                    selected={status === item}
                  >
                    {item}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="payment"> Payment (Rupees)</label>
            <input
              type="number"
              name="payment"
              // type='text'
              // inputMode='numeric'
              // pattern='\d*'
              className="p-2 rounded-lg border border-[#d0d5dd] max-md:h-12 max-md:px-3"
              onChange={(e) => {
                setPayment(e.target.value);
              }}
            />
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="comments"> Comments</label>
            <textarea
              name="comments"
              required={true}
              className="p-2 rounded-lg border border-[#d0d5dd]"
              rows={4}
              onChange={(e) => {
                setComment(e.target.value);
              }}
            ></textarea>
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="file"> File</label>
            <input
              name="file"
              required={true}
              className="p-2 rounded-lg border border-[#d0d5dd]"
              type="file"
              accept=".pdf"
              onChange={(e) => uploadDocument(e)}
            />
          </div>

          <button
            className="p-2 rounded-lg bg-blue text-white text-xl font-medium max-md:mt-2 max-md:h-12 max-md:rounded-xl max-md:py-0 max-md:text-base max-md:font-semibold"
            type="submit"
          >
            Submit
          </button>
        </form>
      )}
      {success && (
        <div className="flex flex-col items-center">
          <img src={ContactSuccess} alt="" />
          <div className="flex flex-col items-center gap-2">
            <div className="text-dark text-center text-xl font-bold mt-8">
              Form Submitted
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RIL;
